<template>
  <b-container class="mt-4">
    <b-card>
      <b-card-body>
        <div style="text-align: center;">
          <h1>
            <span class="text-danger">Access denied for</span>
            <span class="font-weight-bold">{{ module }} </span>
          </h1>
          <p>
            Please select a different module from the study navigation bar or request access for the
            specific module.
          </p>
        </div>
      </b-card-body>
    </b-card>
  </b-container>
</template>

<script>
  export default {
    name: 'NotAllowed',
    props: { module: { type: String, default: 'this module' } },
  };
</script>

<style scoped></style>
